import { lazy } from "react"

export const FormDateTimeField = lazy(() =>
  import("./FormDateTimeField").then((module) => ({
    default: module.FormDateTimeField,
  })),
)
